module.exports = __webpack_public_path__ + "static/img/left6.0635c0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/left6.png
// module id = SIZH
// module chunks = 1